module.exports = __webpack_public_path__ + "img/ring_y_e_1_0@3x.8baa31b4.png";